import { render, staticRenderFns } from "./commonHead.vue?vue&type=template&id=1ecd3ff1&scoped=true&"
import script from "./commonHead.vue?vue&type=script&lang=js&"
export * from "./commonHead.vue?vue&type=script&lang=js&"
import style0 from "./commonHead.vue?vue&type=style&index=0&id=1ecd3ff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd3ff1",
  null
  
)

export default component.exports